import React from 'react'
import compose from 'recompose/compose'
import withWidth from '@material-ui/core/withWidth'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Snackbar from '@material-ui/core/Snackbar'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import amber from '@material-ui/core/colors/amber'
import green from '@material-ui/core/colors/green'
import red from '@material-ui/core/colors/red'
import CloseIcon from '@material-ui/icons/Close'

const styles = theme => ({
  SnackbarForm: {},
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: red[800]
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  message: {
    wordBreak: 'break-all'
  }
})

const SnackbarForm = props => {
  const { classes, proxy, ...others } = props
  const { data = {}, snackbarKey } = others
  const {
    open,
    message = '',
    variant = 'default',
    snackbarProps = {},
    request = {},
    actions = []
  } = data
  const { helper } = request
  const { onClose, onClickHelper } = proxy
  return (
    <div className={classes.SnackbarForm}>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={open}
        autoHideDuration={5000}
        onClose={onClose}
        ContentProps={{
          'aria-describedby': 'message-id',
          className: classes[variant]
        }}
        message={
          <span id="message-id" className={classes.message}>
            {message}
          </span>
        }
        action={actions.concat([
          <Grid container spacing={1}>
            {helper && helper?.message && (
              <Grid item>
                <Button
                  size="small"
                  color="inherit"
                  variant="outlined"
                  onClick={onClickHelper}
                >
                  도움말
                </Button>
              </Grid>
            )}
            <Grid item>
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                size="small"
                onClick={(e, reason) =>
                  snackbarProps.onClose
                    ? snackbarProps.onClose(e, reason, snackbarKey)
                    : onClose(e, reason, snackbarKey)
                }
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        ])}
        {...snackbarProps}
      />
    </div>
  )
}
SnackbarForm.defaultProps = {}
SnackbarForm.propTypes = {
  classes: PropTypes.object.isRequired
}

export default compose(withStyles(styles), withWidth())(SnackbarForm)
